var map = {
	"./banks-logos/ru-alfa.svg": "d813",
	"./banks-logos/ru-atb.svg": "d6ae",
	"./banks-logos/ru-binbank.svg": "0553",
	"./banks-logos/ru-ceb.svg": "e381",
	"./banks-logos/ru-cetelem.svg": "2db4",
	"./banks-logos/ru-citi.svg": "c672",
	"./banks-logos/ru-gpb.svg": "5a67",
	"./banks-logos/ru-hcf.svg": "dc82",
	"./banks-logos/ru-mts.svg": "994a",
	"./banks-logos/ru-novikom.svg": "8495",
	"./banks-logos/ru-open.svg": "ec4b",
	"./banks-logos/ru-otp.svg": "e7ed",
	"./banks-logos/ru-pochta.svg": "3424",
	"./banks-logos/ru-psb.svg": "7bd3",
	"./banks-logos/ru-raiffeisen.svg": "754f",
	"./banks-logos/ru-rgs.svg": "a4d2",
	"./banks-logos/ru-rosbank.svg": "0a4f",
	"./banks-logos/ru-rsb.svg": "4412",
	"./banks-logos/ru-rshb.svg": "575a",
	"./banks-logos/ru-sberbank.svg": "a965",
	"./banks-logos/ru-smp.svg": "c21b",
	"./banks-logos/ru-tinkoff.svg": "51f4",
	"./banks-logos/ru-ucb.svg": "215a",
	"./banks-logos/ru-uralsib.svg": "0ec0",
	"./banks-logos/ru-vbrr.svg": "ad8b",
	"./banks-logos/ru-veb.svg": "75b4",
	"./banks-logos/ru-vozrozhdenie.svg": "34f7",
	"./banks-logos/ru-vtb.svg": "2098",
	"./banks-logos/ru-zenit.svg": "c228",
	"./brands-logos/american-express-black.svg": "1ff8",
	"./brands-logos/american-express-colored.svg": "9039",
	"./brands-logos/american-express-white.svg": "6c50",
	"./brands-logos/diners-club-black.svg": "dc24",
	"./brands-logos/diners-club-colored.svg": "67e8",
	"./brands-logos/diners-club-white.svg": "503f",
	"./brands-logos/discover-black.svg": "6b9a",
	"./brands-logos/discover-colored.svg": "265e",
	"./brands-logos/discover-white.svg": "59ef",
	"./brands-logos/jcb-black.svg": "78fb",
	"./brands-logos/jcb-colored.svg": "4c9f",
	"./brands-logos/jcb-white.svg": "34e4",
	"./brands-logos/maestro-black.svg": "9b1a",
	"./brands-logos/maestro-colored.svg": "edc6",
	"./brands-logos/maestro-white.svg": "2ab2",
	"./brands-logos/master-card-black.svg": "282b9",
	"./brands-logos/master-card-colored.svg": "0801",
	"./brands-logos/master-card-white.svg": "c287",
	"./brands-logos/mir-black.svg": "a480",
	"./brands-logos/mir-colored.svg": "3187",
	"./brands-logos/mir-white.svg": "9899",
	"./brands-logos/unionpay-black.svg": "d4be",
	"./brands-logos/unionpay-colored.svg": "d8ef",
	"./brands-logos/unionpay-white.svg": "a95f",
	"./brands-logos/visa-black.svg": "eb60",
	"./brands-logos/visa-colored.svg": "e45d",
	"./brands-logos/visa-white.svg": "6ff6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c229";